// Base URL for the public trail API (magicaltrails.io). Overridable via
// VITE_API_BASE_URL for local development against a dev backend; the
// production default stays hardcoded so deployed PWAs keep working without
// any env plumbing.
const envBaseUrl: unknown = import.meta.env?.VITE_API_BASE_URL;

// Trailing slashes are trimmed so consumers can safely append `/api/...`
// paths without producing double slashes.
export const API_BASE_URL: string =
  typeof envBaseUrl === 'string' && envBaseUrl.trim() !== ''
    ? envBaseUrl.trim().replace(/\/+$/, '')
    : 'https://magicaltrails-magicaltrails-io.vercel.app';
